import React, { useContext, useEffect } from 'react'
import AppTable from '../table/AppTable'
import styles from './SoldTicketError.module.css'
import { CircularProgress } from '@mui/material'
import {  formatDates } from '../../../helper'
import ToasterWithMessage from '../toaster'
import { useMutation } from '@apollo/client'
import { GET_SOLD_TICKETS_ERROR } from '../../../features/ErrorDashboard/api/ErrorQuery'
import moment from 'moment'
import { globalContext } from '../../../Provider/AppProvider'

const SoldTicketsError = (props:any) => {
  const {
    rowsPerPageSold,
    currentPageSold,
    setCurrentPageSold,
    checking,
    setChecking,
    soldTicketErrorList,
    setSoldTicketErrorList,
    columnTypes,
    setColumnTypes,
    sortType,
    setSortType,
    selected,
    setSelected,
    datesForApiCall,
    selectedStartDate,
    selectedEndDate,
    GenerateSoldTicketsErrorHeadCells,
    handleChangeRowsPerPageSold,
    handlePageChangeSold
  } = props;
  const {error} = ToasterWithMessage();
  const {globalState,handleGlobalState} = useContext<any>(globalContext)
  const [getSoldTicketsError,{loading}] = useMutation(GET_SOLD_TICKETS_ERROR,{
    fetchPolicy: 'no-cache',
    onCompleted: (errorData) => {
        setSoldTicketErrorList(errorData);
    },
    onError: (err) => {
      error("Something went wrong while fetching error data!");
    }
})




const callSoldTicketsErrorApi = () => {
  const startdateForSoldError = datesForApiCall.fromdate
  const enddateForSoldError = datesForApiCall.enddate
  // const payloadEndDate = moment(datesForApiCall.enddate,'YYYY-MM-DD').add(1,'days');
  const formattedDates = formatDates(startdateForSoldError, enddateForSoldError);
  if(moment(startdateForSoldError).isSameOrBefore(enddateForSoldError,'day')){
    let payload = {};
    if(columnTypes){
      payload = {
        "startDate": formattedDates.formattedStartDate,
        "endDate": formattedDates.formattedEndDate,
        "limit": rowsPerPageSold,
        "offset": (currentPageSold -1)*rowsPerPageSold,
        "orderBy": sortType,
        "orderColumn": columnTypes,
        "status" :globalState.errorStatus.soldTicket
    }
    }else {
      payload = {
        "startDate": formattedDates.formattedStartDate,
        "endDate":  formattedDates.formattedEndDate,
        "limit": rowsPerPageSold,
        "offset": (currentPageSold -1)*rowsPerPageSold,
        "orderBy": sortType,
        "status" :globalState.errorStatus.soldTicket
    }
    }
      getSoldTicketsError({
          variables: payload
      })
      // const tempState = {...globalState};
      // tempState.trigger.soldTicketError = false;
      // handleGlobalState(tempState);
      return;
  }else {
      error("From date must be less than to date");
      return;
  }
};

useEffect(() => {
  callSoldTicketsErrorApi();
// eslint-disable-next-line react-hooks/exhaustive-deps
},[selectedStartDate,
   selectedEndDate,
   sortType,
   columnTypes,
   rowsPerPageSold,
   currentPageSold,
   globalState.errorStatus.soldTicket
  ]);

//   useEffect(() => {
//     if(globalState.trigger.soldTicketError===true){
//       callSoldTicketsErrorApi();
//     }
// // eslint-disable-next-line react-hooks/exhaustive-deps
// },[globalState.trigger.soldTicketError])
  return (
    <>
    {
        loading
    ?
        <div className={styles.TableCircularProgress}>
        <CircularProgress color="primary" size={35} />
        </div>
    :
    <AppTable
        handleChangeRowsPerPage={handleChangeRowsPerPageSold}
        handlePageChange={handlePageChangeSold}
        setColumnTypes={setColumnTypes}
        sortType={sortType}
        setSortType={setSortType}
        setChecking={setChecking}
        checking={checking}
        rowsPerPage={rowsPerPageSold}
        setCurrentPage={setCurrentPageSold}
        currentPage={currentPageSold}
        list={soldTicketErrorList}
        // list={dummyerrorData}
        tableTitle="soldTicketsError"
        selected={selected}
        setSelected={setSelected}
        generateHeadCells={GenerateSoldTicketsErrorHeadCells}
    />
    }
    </>
  )
}

export default SoldTicketsError